import { render, staticRenderFns } from "./CreateDns.vue?vue&type=template&id=2b8f5ca2"
import script from "./CreateDns.vue?vue&type=script&lang=js"
export * from "./CreateDns.vue?vue&type=script&lang=js"
import style0 from "./CreateDns.vue?vue&type=style&index=0&id=2b8f5ca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports